import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/index.js";
import { cdnIconVariants } from "./CdnIcon.variants.js";
function CdnIcon({ className, iconName, title, ...props }) {
    const classes = cn(cdnIconVariants(props), 'notranslate', className);
    return iconName ? /*#__PURE__*/ jsx("span", {
        className: classes,
        title: title,
        children: iconName
    }) : /*#__PURE__*/ jsx("span", {
        "data-testid": "empty-icon",
        className: classes,
        title: title
    });
}
export { CdnIcon };
